export default __webpack_public_path__ + "static/media/logo-txt.d8a14fde.svg";